import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { type Locale, SUPPORTED_LOCALES, isSupportedLocale } from '@/i18n';

/**
 * Hook central pra trocar idioma:
 * - persiste em localStorage
 * - navega pra mesma rota no novo idioma
 * - atualiza HTML lang
 */
export function useLanguage() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { locale: currentLocale } = useParams<{ locale: string }>();

  const current = (isSupportedLocale(currentLocale ?? '') ? currentLocale : 'pt-BR') as Locale;

  const change = useCallback(
    (next: Locale) => {
      if (!SUPPORTED_LOCALES.includes(next)) return;
      window.localStorage.setItem('preferred_locale', next);
      // mantem path interno, troca primeiro segmento
      const parts = location.pathname.split('/').filter(Boolean);
      if (parts.length > 0) {
        parts[0] = next;
      } else {
        parts.push(next);
      }
      const newPath = '/' + parts.join('/') + (location.search || '');
      void i18n.changeLanguage(next);
      document.documentElement.lang = next;
      navigate(newPath, { replace: false });
    },
    [i18n, location, navigate],
  );

  return { current, change, supported: SUPPORTED_LOCALES };
}
